var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errPage-container"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/401_images/401.gif"),"width":"313","height":"428","alt":"Girl has dropped her ice cream."}}),_c('h2',[_vm._v("没有权限查看该页面")])])])
}]

export { render, staticRenderFns }